import { ErrorMessage, Formik } from "formik";
import { Button, Typography, Alert, Box } from "@mui/material";
import CustomTextInput from "../../app/common/form/CustomTextInput";
import { useStore } from "../../app/stores/store";

export default function LoginForm() {
    const userStore = useStore((s) => s.userStore);

    return (
        <Formik
            initialValues={{ email: "", password: "", error: null }}
            onSubmit={(values, { setErrors }) =>
                userStore.login(values).catch(() =>
                    setErrors({ error: "Invalid email or password" })
                )
            }
        >
            {({ handleSubmit, isSubmitting, errors }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" align="center" color="primary">
                            Prijava u aplikaciju
                        </Typography>
                    </Box>
                    <CustomTextInput placeholder="Email" name="email" />
                    <CustomTextInput placeholder="Password" name="password" type="password" />
                    <ErrorMessage
                        name="error"
                        render={() => (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {errors.error}
                            </Alert>
                        )}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                        disabled={isSubmitting}
                        sx={{ mt: 2 }}
                    >
                        Prijavi se
                    </Button>
                </form>
            )}
        </Formik>
    );
}